// extracted by mini-css-extract-plugin
export var h5 = "cameraGeneralInformation-module--h5--b2fa2";
export var image = "cameraGeneralInformation-module--image--34883";
export var removeCamera = "cameraGeneralInformation-module--removeCamera--50bfe";